export const measureItemWidths = (container: HTMLElement | null): number[] => {
	if (!container) {
		return [];
	}

	const children = Array.from(container.children) as HTMLElement[];

	return children.map((child) => {
		const style = getComputedStyle(child);

		return child.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight);
	});
};
